import { ReplaceParam } from '@lib/interfaces';
import { ErrorCommonInfo } from '@lib/interfaces/errors';

export interface BookingSearch {
  afterDepartureDate?: {
    reservationNumber?: AfterDepartureDateReservationNumber;
    eTicketNumber?: AfterDepartureDateETicketNumber;
  };
  beforeDepartureDate?: {
    reservationNumber?: BeforeDepartureDateReservationNumber;
    confirmationNumber?: BeforeDepartureDateConfirmationNumber;
    openEndedTicket?: BeforeDepartureDateOpenEndedTicket;
  };
  /** Check Departure Date */
  isAfterDepartureDate?: boolean;
  /** Search Reservation By */
  selectItemValue?: number;
  /** Departure Date Selection */
  selectDepartureDateValue?: number;
  /** エラーメッセージID */
  errorMessageList?: ErrorCommonInfo[];
  /** ワーニングメッセージID */
  warningMessageList?: WarningMessage[];
}

export interface WarningMessage {
  errorMessageId?: string;
  apiErrorCode?: string;
  interpolateParams?: Object;
}

export interface AfterDepartureDateReservationNumber {
  /** 予約番号 */
  orderId?: string | null;
  /** 搭乗者名（名） */
  firstName?: string | null;
  /** 搭乗者名（姓） */
  lastName?: string | null;
}

export interface AfterDepartureDateETicketNumber {
  /** 航空券番号 */
  eTicketNumber?: string | null;
  /** 搭乗者名（名） */
  firstName?: string | null;
  /** 搭乗者名（姓） */
  lastName?: string | null;
}

export interface BeforeDepartureDateReservationNumber {
  /** 出発日 */
  departureDate?: Date | null;
  /** 便番号 */
  flightNumber?: string | null;
  /** 予約番号 */
  orderId?: string | null;
  /** 搭乗者名（名） */
  firstName?: string | null;
  /** 搭乗者名（姓） */
  lastName?: string | null;
}

export interface BeforeDepartureDateConfirmationNumber {
  /** 出発日 */
  departureDate?: Date | null;
  /** 便番号 */
  flightNumber?: string | null;
  /** 確認番号 */
  confirmationNumber?: string | null;
  /** 搭乗者名（名） */
  firstName?: string | null;
  /** 搭乗者名（姓） */
  lastName?: string | null;
}

export interface BeforeDepartureDateOpenEndedTicket {
  /** 確認番号 */
  confirmationNumber?: string | null;
  /** 搭乗者名（名） */
  firstName?: string | null;
  /** 搭乗者名（姓） */
  lastName?: string | null;
}

export const INITIAL_BOOKINGSEARCH_STATE: BookingSearch = {
  afterDepartureDate: {
    reservationNumber: {
      /** 予約番号 */
      orderId: '',
      /** 搭乗者名（名） */
      firstName: '',
      /** 搭乗者名（姓） */
      lastName: '',
    },
    eTicketNumber: {
      /** 航空券番号 */
      eTicketNumber: '',
      /** 搭乗者名（名） */
      firstName: '',
      /** 搭乗者名（姓） */
      lastName: '',
    },
  },
  beforeDepartureDate: {
    reservationNumber: {
      /** 出発日 */
      departureDate: null,
      /** 便番号 */
      flightNumber: '',
      /** 予約番号 */
      orderId: '',
      /** 搭乗者名（名） */
      firstName: '',
      /** 搭乗者名（姓） */
      lastName: '',
    },
    confirmationNumber: {
      /** 出発日 */
      departureDate: null,
      /** 便番号 */
      flightNumber: '',
      /** 確認番号 */
      confirmationNumber: '',
      /** 搭乗者名（名） */
      firstName: '',
      /** 搭乗者名（姓） */
      lastName: '',
    },
    openEndedTicket: {
      /** 確認番号 */
      confirmationNumber: '',
      /** 搭乗者名（名） */
      firstName: '',
      /** 搭乗者名（姓） */
      lastName: '',
    },
  },
  /** Check Departure Date */
  isAfterDepartureDate: true,
  /** Search Reservation By */
  selectItemValue: 0,
  /** Departure Date Selection */
  selectDepartureDateValue: 1,
};
